import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import NovedadesProductos from "../../components/NovedadesProductos";
import { marcarInicioFlujoCompra, listarBorradoresModificar } from "../../utils/flujoCompra";
import { hoyMadrid } from "../../utils/fecha";

// Compras NUEVAS a medias guardadas en el móvil (de hoy y con productos): las mismas que
// la lista de pisos de "Crear compras" marca como en progreso.
const contarComprasAMedias = () => {
  let n = 0;
  try {
    const hoy = hoyMadrid();
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k || !/^compraData_piso_\d+$/.test(k)) continue;
      try {
        const d = JSON.parse(localStorage.getItem(k) || "null");
        if (d && d.fecha === hoy && Array.isArray(d.productos) && d.productos.length > 0) n += 1;
      } catch (_) { /* borrador ilegible: no cuenta */ }
    }
  } catch (_) { /* sin storage */ }
  return n;
};

const SupervisoraCompras = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const usuario = user?.user || user || "";
  const [aviso, setAviso] = useState(location.state?.aviso || null);
  const [puedeVerDatos, setPuedeVerDatos] = useState(false);

  useEffect(() => {
    if (location.state?.aviso) {
      // Limpiar el state para que no reaparezca al navegar
      window.history.replaceState({}, "", window.location.pathname);
      const t = setTimeout(() => setAviso(null), 5000);
      return () => clearTimeout(t);
    }
  }, [location.state?.aviso]);

  useEffect(() => {
    let cancelado = false;
    axios.get("/api/servicio/opciones_supervisora_media/mi_estado")
      .then((r) => { if (!cancelado) setPuedeVerDatos(!!r.data?.habilitado); })
      .catch(() => { if (!cancelado) setPuedeVerDatos(false); });
    return () => { cancelado = true; };
  }, []);

  // compras con cambios sin confirmar (guardados en el móvil): número rojo en el botón
  const [pendientesModificar] = useState(() => listarBorradoresModificar().length);
  const [pendientesCrear] = useState(() => contarComprasAMedias());

  const optionsBase = [
    {
      title: "Crear compras",
      image: "/images/gestion_productos.png",
      badge: pendientesCrear,
      badgeTitulo: (n) => `${n} compra${n === 1 ? "" : "s"} empezada${n === 1 ? "" : "s"} sin confirmar`,
      action: () => { marcarInicioFlujoCompra(); navigate("/supervisora/pisoCrearCompras"); },
    },
    {
      title: "Modificar compras",
      image: "/images/modificarCompras.png",
      badge: pendientesModificar,
      action: () => { marcarInicioFlujoCompra(); navigate("/supervisora/modificarVerCompras", { state: { modo: "modificar" } }); },
    },
    {
      title: "Ver estado de compras",
      image: "/images/estadoCompras.png",
      action: () => navigate("/supervisora/modificarVerCompras", { state: { modo: "ver" } }),
    },
    {
      title: "Seguimiento del día",
      image: "/images/seguimiento.png",
      path: "/supervisora/SeguimientoDelDia",
    },
    {
      title: "Calendario limpiezas",
      image: "/images/calendario-limpiezas.jpg",
      path: "/supervisora/calendario-limpiezas",
    },
    {
      title: "Gastos",
      image: "/images/prestamos.png",
      path: "/supervisora/prestamos",
    },
    {
      title: "Ver datos compras",
      image: "/images/analisis_datos.png",
      path: "/supervisora/verDatosCompras",
      soloSiPuedeVerDatos: true,
    },
  ];

  const options = optionsBase.filter((o) => !o.soloSiPuedeVerDatos || puedeVerDatos);

  return (
    <div style={{ ...styles.container, position: "relative" }}>
      <div style={{ position: "absolute", top: 12, left: 12, zIndex: 50 }}>
        <button
          onClick={() => navigate("/supervisora")}
          style={styles.btnVolver}
        >
          ← Volver
        </button>
      </div>

      <h1 style={styles.title}>
        🛍️🛒 Compras — <strong style={{ color: "#007bff" }}>{usuario}</strong>
      </h1>

      {aviso && (
        <div style={{ background: "#fef3c7", border: "1px solid #f59e0b", borderRadius: 8, padding: "10px 16px", marginBottom: 16, textAlign: "center", color: "#92400e", fontSize: 14 }}>
          {aviso}
        </div>
      )}

      <NovedadesProductos />

      <div style={styles.buttonContainer}>
        {options.map((option) => (
          <button
            key={option.title}
            onClick={() => option.action ? option.action() : navigate(option.path)}
            style={{ ...styles.button, position: "relative" }}
          >
            <img src={option.image} alt={option.title} style={styles.image} onError={(e) => { if (!e.currentTarget.dataset.fallback) { e.currentTarget.dataset.fallback = "1"; e.currentTarget.src = "/images/estadoCompras.png"; } }} />
            <span style={styles.label}>{option.title}</span>
            {option.badge > 0 && (
              <span
                title={option.badgeTitulo ? option.badgeTitulo(option.badge) : `${option.badge} compra${option.badge === 1 ? "" : "s"} con cambios sin confirmar`}
                style={{
                  position: "absolute", top: -10, right: -10, minWidth: 28, height: 28, padding: "0 8px",
                  borderRadius: 999, background: "#e11d48", color: "#fff", fontWeight: 900, fontSize: 15,
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(225,29,72,0.45)", border: "2px solid #fff",
                }}
              >
                {option.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "40px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    minHeight: "100vh",
  },
  title: { marginBottom: "30px", color: "#333", marginTop: 60 },
  buttonContainer: { display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" },
  button: {
    width: "90%", maxWidth: "400px", padding: "20px",
    border: "2px solid #007bff", borderRadius: "10px",
    backgroundColor: "transparent", display: "flex",
    alignItems: "center", justifyContent: "center",
    gap: "20px", cursor: "pointer", transition: "all 0.2s ease-in-out",
  },
  image: { width: "50px", height: "50px", objectFit: "contain" },
  label: { fontSize: "20px", fontWeight: "bold", color: "#007bff", textAlign: "center" },
  btnVolver: {
    padding: "10px 22px", borderRadius: 20,
    background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
    color: "#fff", border: "none", cursor: "pointer",
    fontWeight: 700, fontSize: 15,
    boxShadow: "0 2px 8px rgba(29,78,216,0.35)",
  },
};

export default SupervisoraCompras;
